import { LoanSummary } from '@/interfaces/loans/queries';

export const isLoanSummaryListTypeChecker = (
  summary: LoanSummary | LoanSummary[]
): summary is LoanSummary[] => Array.isArray(summary);
